import styled from 'styled-components'

const SocialMediaVinculationStyled = styled.div`
  margin-block-start: 40px;
  .icon-container {
    border: 8px solid ${({ color }) => color};
    background: ${({ color }) => color};
    border-radius: 50%;
    block-size: 48px;
    inline-size: 48px;
  }
  .icon-vinculated {
    background: ${({ color }) => color};
  }
  a {
    height: fit-content;
    align-self: center;
  }
  p {
    color: var(--neutral40);
  }
  @media(min-width: 768px) {
    display: flex;
    .vinculation-copy {
      max-width: 607px;
      margin-inline-start: 16px;
      margin-inline-end: 24px;
    }
  }
`

export default SocialMediaVinculationStyled
